import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type SyncDateWindowConstructor,
  SyncDateWindow,
} from './SyncDateWindow'

export const SyncDateWindowConstructorFactory =
  Factory.Sync.makeFactory<SyncDateWindowConstructor>({
    startDate: Factory.each(() => faker.date.past()),
    endDate: null,
  })

export const SyncDateWindowFactory = EntityFactory(
  SyncDateWindow,
  SyncDateWindowConstructorFactory
)
